var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.584,
    height: 46.5,
    viewBox: "0 0 26.584 46.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    d: "M29.821,29.438,12.226,11.857a3.323,3.323,0,1,1,4.707-4.693l19.934,19.92a3.317,3.317,0,0,1,.1,4.582L16.947,51.725a3.323,3.323,0,1,1-4.707-4.693Z",
    transform: "translate(-11.251 -6.194)",
    fill: "#F95E4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowOrange);
export default __webpack_public_path__ + "static/media/rightArrowOrange.da56d2d485fb45d10e952547641ce686.svg";
export { ForwardRef as ReactComponent };